function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "eh_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.7,
  d: "M-158.7 0H524v512h-682.7z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#eh_svg__a)",
  transform: "translate(148.8) scale(.94)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-180 0H844v256H-180z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#107b00",
  d: "M-180 256H844v256H-180z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-180 169.3H844v176.1H-180z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f0f",
  d: "M310 195.6c-45.2-19.5-84.1 20.6-84 58 0 39.2 38 81 86 62.5-34-10-48-35.3-48-60.7-.3-25.2 15.8-54.6 46-59.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff1800",
  d: "M363.1 294.2l-25.8-18.9-26 19 10-30.5-26-18.8h32l9.9-30.5 9.8 30.4h32.1l-25.9 18.8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "red",
  d: "M314.3 315.6a65.2 65.2 0 01-89.2-59.4 65 65 0 0189.5-60.9 60.6 60.6 0 00-51.2 59.2 61.3 61.3 0 0051 61.1zM-180 0l348.6 256.6L-180 512V0z"
}));

var SvgEh = function SvgEh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2);
};

export default SvgEh;